import { render, staticRenderFns } from "./StandaloneWpEdit.vue?vue&type=template&id=3f8e85d1&scoped=true&"
import script from "./StandaloneWpEdit.vue?vue&type=script&lang=js&"
export * from "./StandaloneWpEdit.vue?vue&type=script&lang=js&"
import style0 from "./StandaloneWpEdit.vue?vue&type=style&index=0&id=3f8e85d1&lang=scss&scoped=true&"
import style1 from "./StandaloneWpEdit.vue?vue&type=style&index=1&id=3f8e85d1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f8e85d1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3f8e85d1')) {
      api.createRecord('3f8e85d1', component.options)
    } else {
      api.reload('3f8e85d1', component.options)
    }
    module.hot.accept("./StandaloneWpEdit.vue?vue&type=template&id=3f8e85d1&scoped=true&", function () {
      api.rerender('3f8e85d1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/workPermits/StandaloneWpEdit.vue"
export default component.exports